import { Injectable, NgZone } from '@angular/core'
import { Subject } from 'rxjs'

interface LogRocket {
    getSessionURL(cb: (sessionUrl: string) => void): void
    identify(id?: string, userdata?: { name: string; email: string }): void
}

@Injectable({ providedIn: 'root' })
export class LogRocketService {
    public logRocket$ = new Subject<LogRocket | undefined>()

    constructor(private ngZone: NgZone) {
        let intervalGap = 50
        this.ngZone.runOutsideAngular(() => {
            const interval = setInterval(() => {
                intervalGap++
                if (this.logRocket) {
                    clearInterval(interval)
                    this.logRocket$.next(this.logRocket)
                }
                intervalGap++
            }, intervalGap)
        })
    }

    get logRocket(): LogRocket | undefined {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return window.LogRocket as LogRocket | undefined
    }
}
